export const supportToolsEnabled = state => {
  return state.supportTools.status;
};
